/*
 * @Author: LiuChuanQi
 * @Date: 2022-12-08 12:20:45
 * @LastEditTime: 2023-02-13 12:04:18
 * @LastEditors: LiuChuanQi
 * @Description: 
 * @FilePath: \speedtest-bigdata-v2\src\utils\hooks\utils.js
 * 
 */


export const getChineseLength = function (str) {
  var len = 0
  for (var i = 0; i < str.length; i++) {
    var c = str.charCodeAt(i)
    //单字节加1 
    if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
      len++
    } else {
      len += 2
    }
  }
  return len
}


export const getQueryParams = function (url) {
  if (url.includes("?")) {
    const paramArr = url.slice(url.indexOf("?") + 1).split("&")
    const params = {}
    paramArr.map((param) => {
      const [key, val] = param.split("=")
      params[key] = decodeURIComponent(val)
    })
    return params
  } else {
    return ''
  }


}

